import { integerQueryParamSchema } from '@agilelab/plugin-wb-platform-common';
import { z } from 'zod';

export const ServiceAccountBaseSchema = z.object({
  email: z.string().email(),
  displayName: z.string().optional(),
  groups: z.array(z.string()).optional(),
});

export type ServiceAccountBase = z.infer<typeof ServiceAccountBaseSchema>;

export const ServiceAccountsDeleteRequestSchema = z.object({
  userRefs: z.union([z.array(z.string()), z.string()]).optional(),
});

export type ServiceAccountDeleteRequest = z.infer<
  typeof ServiceAccountsDeleteRequestSchema
>;

export const ServiceAccountsWatchRequestSchema = z.object({
  after: integerQueryParamSchema,
  timeout: integerQueryParamSchema.optional(),
});

export type ServiceAccountsWatchRequest = z.infer<
  typeof ServiceAccountsWatchRequestSchema
>;
